import { useQuery } from "react-query";
import { getUserDetails } from "services/user.service";

export default function useProfile(id) {
  return useQuery(["profile", id], async () => await getUserDetails(id), {
    enabled: id ? true : false,
  });
}
